// This file exists to import everything else (and define the module exports).
// It is the root for building the bundle.

import { Comical } from "./comical";
import { Bubble } from "./bubble";
import { BubbleSpec, BubbleSpecPattern, TailSpec } from "./bubbleSpec";

export { Comical, Bubble, BubbleSpec, BubbleSpecPattern, TailSpec };
